import departureCity from './toRouter/departureCity';
import checkInDateRange from './toRouter/checkInDateRange';
import nightRange from './toRouter/nightRange';
import touristGroup from './toRouter/touristGroup';
import operators from './toRouter/operators';
import priceRange from './toRouter/priceRange';
import directFlights from './toRouter/directFlights';
import meals from './toRouter/meals';
import warranted from './toRouter/warranted';
import block from './toRouter/block';

export default (urlParams) => {
    const {
        tourCriteria,
        identity,
        activeTab,
        similar = false,
        sid,
        prepayments,
        hsid,
        bonusMiles = false,
    } = urlParams;

    let params = {
        ...departureCity(tourCriteria),
        ...checkInDateRange(tourCriteria),
        ...nightRange(tourCriteria),
        ...touristGroup(tourCriteria),
        ...operators(tourCriteria),
        ...warranted(tourCriteria),
        ...directFlights(tourCriteria),
        ...block(tourCriteria),
    };

    if (!similar) {
        params = {
            ...params,
            ...priceRange(tourCriteria),
            ...meals(tourCriteria),
        };
    }

    if (identity) {
        params.identity = identity;
    }

    if (activeTab) {
        params.activeTab = activeTab;
    }

    if (sid) {
        params.sid = sid;
    }

    if (prepayments?.length) {
        params.prepayments = prepayments;
    }
    if (hsid) {
        params.hsid = hsid;
    }

    if (bonusMiles) {
        params.bonusMiles = bonusMiles;
    }

    return params;
};